import { MeetingRoomCalendar } from "@/components/MeetingRoomCalendar";
import { LoginGate } from "@/components/LoginGate";
import "./index.css";

export function App() {
  return (
    <LoginGate>
      {(user, signOut) => (
        <MeetingRoomCalendar user={user} onSignOut={signOut} />
      )}
    </LoginGate>
  );
}

export default App;
